export function sortBy(predicate, items) {
  const itemsCopy = [...items];
  itemsCopy.sort(predicate);
  return itemsCopy;
}